const state = {
  campaigns: [],
  ads: []
};

const getters = {
  campaigns: (state) => {
    return state.campaigns || [];
  },
  ads: (state) => {
    return state.ads || [];
  }
};

const mutations = {
  SET_CAMPAIGNS(state, items) {
    state.campaigns = items;
  },
  SET_ADS(state, items) {
    state.ads = items;
  }
};

const actions = {
  getCampaigns({ commit }) {
    return new Promise((resolve, reject) => {
      this._vm.$http
        .get('reports/getCampaigns')
        .then((response) => {
          commit('SET_CAMPAIGNS', response.data);
          resolve();
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  getAds({ commit }) {
    return new Promise((resolve, reject) => {
      this._vm.$http
        .get('reports/getAds')
        .then((response) => {
          commit('SET_ADS', response.data);
          resolve();
        })
        .catch((error) => {
          reject(error);
        });
    });
  }
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};
